module.exports = __webpack_public_path__ + "8e8a58ae03874988a223738b9e5669b2.png";